'use client';

import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { termsOfLocationData } from '@/mock/terms-of-location-dummy';
import { personalInfoCollectionData } from '@/mock/terms-of-personal-info-collection-dummy';
import { personalInfoProcessingData } from '@/mock/terms-of-personal-info-processing-dummy';
import { termsOfServiceData } from '@/mock/terms-of-service-dummy';
import { TermsNameType } from '@/types/terms.type';

interface TermsProps {
  name: string;
  displayTitle?: boolean;
}

const TermsLayout: React.FC<TermsProps> = ({ name, displayTitle }) => {
  const dummyData =
    name === TermsNameType.TERMS_OF_SERVICE
      ? termsOfServiceData
      : name === TermsNameType.LOCATION_INFO_COLLECTION
        ? termsOfLocationData
        : name === TermsNameType.PERSONAL_INFO_COLLECTION
          ? personalInfoCollectionData
          : name === TermsNameType.PERSONAL_INFO_PROCESSING
            ? personalInfoProcessingData
            : undefined;

  if (dummyData === undefined) {
    return (
      <div
        className="flex h-screen bg-bg-blueGreyDeep p-4"
        style={{ overflow: 'auto', WebkitOverflowScrolling: 'touch' }}
      >
        <div className="flex h-screen w-full flex-col">
          주소가 잘못 입력 되었습니다.
        </div>
      </div>
    );
  }

  return (
    <div className="flex bg-bg-blueGreyDeep p-4">
      <div className="flex w-full flex-col">
        {dummyData &&
          dummyData.map((item, index) => (
            <div key={index} className="">
              {displayTitle && item.title && (
                <div
                  key={'title_' + index}
                  className="flex w-full justify-center whitespace-pre-line"
                >
                  <p className="text-lg font-bold">{item.title}</p>
                </div>
              )}
              {item.title1 && (
                <div
                  key={'title1_' + index}
                  className="flex w-full justify-start whitespace-pre-line"
                >
                  <p className="text-md font-bold">{item.title1}</p>
                </div>
              )}
              {item.title2 && (
                <div
                  key={'title2_' + index}
                  className="flex w-full justify-start whitespace-pre-line"
                >
                  <p className="text-sm font-bold">{item.title2}</p>
                </div>
              )}
              {item.discription1 && (
                <div
                  key={'discription1_' + index}
                  className="flex w-full justify-start whitespace-pre-line"
                >
                  <p className="text-sm">{item.discription1}</p>
                </div>
              )}
              {item.discription2 && (
                <div key={'discription2_' + index}>
                  {item.discription2.map((subitem, idx) => (
                    <div
                      key={'discription2_sub_' + idx}
                      className="flex w-full justify-start whitespace-pre-line px-2"
                    >
                      <p className="text-sm">{subitem[0]}</p>
                      <div className="pl-1">
                        <p className="text-sm">{subitem[1]}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {item.discription3 && (
                <div key={'discription3_' + index}>
                  {item.discription3.map((subitem, idx) => (
                    <div
                      key={'discription3_sub_' + idx}
                      className="flex w-full justify-start whitespace-pre-line px-4"
                    >
                      <div className="text-sm">{subitem[0]}</div>
                      <div className="pl-1">
                        <div className="text-sm">{subitem[1]}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {item.table && (
                <div key={'table_' + index} className="">
                  <h4 className="text-md font-medium text-gray-400">
                    {item.table.title}
                  </h4>
                  <Table className="table-fixed border bg-white">
                    {item.table.headers && (
                      <TableHeader>
                        <TableRow className="bg-bg-infoBox">
                          {item.table.headers.map((header, idx) => (
                            <TableHead
                              key={idx}
                              colSpan={header.colSpan || 1}
                              className="border border-[#CFD2DB] p-2 text-center text-gray-800"
                            >
                              {header.title}
                            </TableHead>
                          ))}
                        </TableRow>
                      </TableHeader>
                    )}
                    <TableBody>
                      {item.table.rows.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                          {row.cells.map((cell, cellIndex) => (
                            <TableCell
                              key={cellIndex}
                              colSpan={cell.colSpan || 1}
                              rowSpan={cell.rowSpan || 1}
                              className="w-1/3 whitespace-pre-wrap break-words border border-[#CFD2DB] p-2 text-left align-top text-text-level3"
                            >
                              {cell.value}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
              {item.lineBreak && (
                <div
                  key={'lineBreak_' + index}
                  className="flex w-full justify-start whitespace-pre-line"
                >
                  <p className="text-sm">{'\n'}</p>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default TermsLayout;
